// extracted by mini-css-extract-plugin
export var headerNavMenu = "HeaderNavMenu_headerNavMenu__SrhIF";
export var navLink = "HeaderNavMenu_navLink__uLGgn";